import React from 'react';
import PropTypes from 'prop-types';

import {black500} from "assets/jss/main";

import RunnerAvatar from "./RunnerAvatar";

RunnerName.propTypes = {
    runner: PropTypes.object.isRequired,
};

function RunnerName({runner}) {
    return (
        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
            <RunnerAvatar runner={runner} />
            <span style={{color: black500, fontWeight: 600}}>
                {runner?.user?.familyName}
            </span>
        </div>
    );
}

export default RunnerName;
